import styled from 'styled-components/native';

import { activeOpacity } from '@src/configuration/constants';

const Component = styled.TouchableOpacity.attrs({
  activeOpacity,
})``;

Component.displayName = 'Touchable';

export default Component;
